module.exports = __webpack_public_path__ + "2b72fd6e2e67787e1084e265a5d5a27b.jpg?2a5548aa4baa07149332d671d907848e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2b72fd6e2e67787e1084e265a5d5a27b.jpg
// module id = 116
// module chunks = 0